import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import StopForm from '../forms/stop-form';
import { stopValidationSchema } from '../schema/stop.js';

export default function StopNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Stop Node Details',
        altText: 'Stop Node',
        defaultLabel: data?.command || 'Stop Node',
        forceDefaultLabel: true,
      }}
    >
      <CommonNode FormComponent={StopForm} schemaResolver={stopValidationSchema} />
    </NodeProvider>
  );
}
